<template lang="pug">
div
  vm-row.information__wrapper(
    vm-w="12",
    vm-type="flex",
    vm-justify="space-between"
  )
    vm-col.gutters(vm-sm=12, vm-md=6, vm-lg=4)
      .card.card-primary
        .card-body
          h4 TOTAL FACTURADO
          h3 {{ amountInvoices | currency }}
    vm-col.gutters(vm-sm=12, vm-md=6, vm-lg=4)
      .card
        .card-body
          h4 TOTAL PAGADO
          h3 {{ totalPaid | currency }}
    vm-col.gutters(vm-sm=12, vm-md=6, vm-lg=4)
      .card
        .card-body
          h4 PENDIENTE DE PAGO
          h3 {{ remaining_amount | currency }}
  vm-row.information__wrapper(vm-type="flex", vm-w=12)
    vm-col.gutters(vm-w=6)
      .card
        .card-body
          h4.purchase__order_title FACTURAS
          vm-row(vm-w="12", vm-type="flex")
            vm-col(vm-w=12)
              vm-table(max-height="500px", :data="invoices")
                template(slot="header")
                  .d-flex.justify-content-between
                template(slot="thead")
                  vm-th(
                    :key="index",
                    v-if="column !== 'id'",
                    v-for="(column, index) in columns"
                  ) {{ $t('invoices.' + column) }}
                template(slot-scope="{ data }")
                  vm-tr(
                    :data="tr",
                    :key="indextr",
                    v-for="(tr, indextr) in data"
                  )
                    vm-td(
                      :data="data[indextr][column]",
                      :key="index",
                      v-if="column !== 'id'",
                      v-for="(column, index) in columns"
                    )
                      .row
                        slot(v-if="column == 'invoice_number'") {{ data[indextr][column] }}
                        slot(v-if="column == 'amount'") {{ data[indextr][column] | currency }}
                        slot(v-if="column == 'created_at'") {{ data[indextr][column] | moment('DD-MMMM-YYYY') }}
                        .actions__wrapper(v-if="column == 'status'")
                          vm-chip(
                            :color="colorStatus(data[indextr]['status_display'])",
                            :pulse="true"
                          ) {{ data[indextr]['status_display'] }}
    vm-col.gutters(vm-w=6)
      .card
        .card-body
          h4.purchase__order_title PAGOS
          vm-row(vm-w="12")
            vm-col(vm-w=12)
              vm-table(max-height="500px", :data="payments")
                template(slot="header")
                  .d-flex.justify-content-between
                template(slot="thead")
                  vm-th(
                    :key="index",
                    v-if="column !== 'id'",
                    v-for="(column, index) in columnsPayments"
                  ) {{ $t('invoices.' + column) }}
                template(slot-scope="{ data }")
                  vm-tr(
                    :data="tr",
                    :key="indextr",
                    v-for="(tr, indextr) in data"
                  )
                    vm-td(
                      :data="data[indextr][column]",
                      :key="index",
                      v-if="column !== 'id'",
                      v-for="(column, index) in columnsPayments"
                    )
                      .row
                        slot(v-if="column == 'invoice'") {{ data[indextr][column].invoice_number }}
                        slot(v-if="column == 'amount'") {{ data[indextr][column] | currency }}
                        slot(v-if="column == 'payment_type'") {{ paymentType(data[indextr][column]) }}
                        slot(v-if="column == 'payment_date'") {{ data[indextr][column] | moment('DD-MMMM-YYYY') }}
                        slot(v-if="column == 'created_at'") {{ data[indextr][column] | moment('DD-MMMM-YYYY') }}
    .floating_sale_amount
      span Importe Venta
      span {{ sale_amount | currency }}
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Invoices')

export default {
  name: 'InvoiceNumbersInformation',
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    columns: ['invoice_number', 'amount', 'created_at', 'status'],
    columnsPayments: ['invoice', 'amount', 'payment_type', 'payment_date', 'created_at'],
    paymentTypes: [
      {
        text: 'Transferencia',
        value: 'transfer'
      },
      {
        text: 'Cheque',
        value: 'check'
      },
      {
        text: 'Efectivo',
        value: 'cash'
      },
      {
        text: 'Otro',
        value: 'other'
      }
    ]
  }),
  computed: {
    ...mapGetters(['amountInvoices', 'totalPaid', 'invoices', 'payments']),
    sale_amount () {
      return this.sale.total
    },
    remaining_amount () {
      return parseFloat(this.sale.total) - parseFloat(this.totalPaid)
    }
  },
  async created () {
    await this.loadAmountInvoices({ sale_id: this.$route.params.id }).then(
      () => {
        this.totalPaidSale({ sale_id: this.$route.params.id }).then(() => {
          this.loadRecords({ sale_id: this.$route.params.id }).then(() => {
            this.loadAllPayments({ sale_id: this.$route.params.id })
          })
        })
      }
    )
  },
  methods: {
    ...mapActions([
      'loadAmountInvoices',
      'totalPaidSale',
      'loadRecords',
      'loadAllPayments'
    ]),
    colorStatus (status) {
      switch (status) {
        case 'Pendiente':
          return '#026481'
        case 'Pagado':
          return 'rgb(23, 201, 100)'
      }
    },
    paymentType (code) {
      return this.paymentTypes.find(e => e.value === code).text
    }
  }
}
</script>

<style lang="scss" scoped>
.floating_sale_amount {
  display: flex;
  justify-content: space-between;
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #0082aa;
  padding: 10px;
  z-index: 20000;
  border-radius: 0.5em;
  span {
    color: #fff;
    padding: 10px;
    &:last-child {
      font-weight: bold;
    }
  }
}

.information__wrapper {
  margin-top: 25px;
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    .card-body {
      padding: 10px !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

#app .crud .heading .vm-col:first-child div:last-child {
  padding-left: 0 !important;
}

.p-0 {
  padding: 0 !important;
}
</style>
